import type { MovementError } from "@features/vessel-call/vessel-call-status/MovementServices/form/utils.ts";
import { addResource as addResourceService } from "@services/movementServicesApi";
import { useMutation } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";

export const useAddResource = ({
  handleSuccess,
  handleError,
}: {
  handleSuccess: () => void;
  handleError: (error: MovementError) => void;
}) => {
  const addResourceMutation = useMutation({
    mutationFn: (variables: Parameters<typeof addResourceService>[0]) =>
      runTransaction(
        {
          module: "vessel_call",
          screen: "MovementService",
          action: "add_resource",
          entityType: "movement_service",
        },
        (transactionId) =>
          addResourceService({
            ...variables,
            ...(transactionId ? { transactionId } : {}),
          }),
      ),
    onSuccess: () => handleSuccess(),
    onError: (error: MovementError) => handleError(error),
  });

  const addResource = async (variables: Parameters<typeof addResourceService>[0]) => {
    addResourceMutation.mutate(variables);
  };

  return {
    addResource,
  };
};
